import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV } from '@atlassian/jira-navigation-apps-horizontal-nav-selector/src/constants.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import AsyncSidebarSoftwareClassic from '@atlassian/jira-navigation-apps-sidebar-software-classic/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProjectSettingsResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { classicProjectSettingsDetailsRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-software-routes/src/classicProjectSettingsDetailsRoute.tsx';
import { ProjectSettingsDetailsSkeleton } from '@atlassian/jira-skeletons/src/ui/project-settings/ProjectSettingsFeaturesSkeleton.tsx';
import { softwareProjectLayout } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point';
import { projectDetailsPageEntrypoint } from '@atlassian/jira-spa-apps-project-settings-details/src/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { softwareOnboardingGetStartedIntegrationsStatusResource } from '@atlassian/jira-router-resources-jsw-onboarding/src/services/get-started-integrations-status/index.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import Details, { LazyDetailsSettings } from './ui/project-settings/details/index.tsx';

const projectSettingsDetailsPageEntrypoint = createPageEntryPoint({
	main: projectDetailsPageEntrypoint,
});

export const classicProjectSettingsDetailsRouteEntry = createEntry(
	classicProjectSettingsDetailsRoute,
	() => ({
		group: 'project-settings-software',
		component: Details,
		skeleton: ProjectSettingsDetailsSkeleton,
		layout: softwareProjectLayout,

		entryPoint: () =>
			fg('jira_project_details_settings_refresh')
				? projectSettingsDetailsPageEntrypoint
				: undefined,

		navigation: {
			horizontal: GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV,
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarSoftwareClassic,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getNavigationSidebarProjectSettingsResource(),
			projectContextResource,
			resourceWithCondition(
				() => fg('jira_slack_and_teams_promotion'),
				softwareOnboardingGetStartedIntegrationsStatusResource,
			),
		],

		forPaint: [LazyAtlassianNavigation, LazyDetailsSettings],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/classicProjectSettingsDetailsRouteEntry.tsx',
				whichExportToUse: 'classicProjectSettingsDetailsRouteEntry',
			},

			enabled: true,
		},
	}),
);
